export const BILL_FREQUENCY_NAME = {
  Monthly: 'Month',
  BiMonthly: 'Bi-Monthly',
  Trimonthly: 'Quarterly',
  Annually: 'Annually'
};
export const BILL_FREQUENCY = {
  Monthly: 'Monthly',
  BiMonthly: 'BiMonthly',
  Trimonthly: 'Trimonthly',
  Annually: 'Annually'
};
export const ALLOCATION_METHOD = {
  ByOccupancy: 'ByOccupancy',
  ByUnit: 'ByUnit',
  BySquareFootage: 'BySquareFootage',
  ByPercentageShare: 'ByPercentageShare',
  BySubmeter: 'BySubmeter',
  By50Occupancy50SquareFootage: 'By50Occupancy50SquareFootage',
  ByNumberOfOccupants: 'ByNumberOfOccupants'
};
export const VACANT_UNIT_ALLOCATIONS = {
  AllocateToOwner: 'AllocateToOwner',
  DivideAmongOccupied: 'DivideAmongOccupied',
  NA: 'NA'
};
export const VACANT_UNIT_ALLOCATIONS_TO_PAID_BY = {
  AllocateToOwner: 'Owner',
  DivideAmongOccupied: 'Resident',
  NA: 'NA'
};
export const PAID_BY_TO_VACANT_UNIT_ALLOCATIONS = {
  Owner: 'AllocateToOwner',
  Resident: 'DivideAmongOccupied',
  NA: 'NA'
};
export const VACANT_UNIT_USAGE = {
  NoUsage: 'NoUsage',
  LimitedUsage: 'LimitedUsage',
  NormalUsage: 'NormalUsage'
};
export const VACANT_UNIT_USAGE_TO_TRANSLATE = {
  NoUsage: 'add_new_property_flow.no_usage',
  LimitedUsage: 'add_new_property_flow.unit_usage_limited_usage',
  NormalUsage: 'add_new_property_flow.full_usage'
};
export const UTILITIES_STATUSES = {
  PendingCompletion: 'PendingCompletion',
  PendingApproval: 'PendingApproval',
  TableReady: 'TableReady',
  TableReadyStatementSent: 'TableReadyStatementSent',
  TableSkipped: 'TableSkipped'
};
export const UTILITY_CONFIGURATION_TYPES = {
  UtilityConfigurator: 'utilityConfigurator',
  CustomUtilityProviderConfigurator: 'customUtilityProviderConfigurator',
  EditCustomUtilityProviderConfigurator: 'editCustomUtilityProviderConfigurator'
};
export const skipReasonTypes = t => ({
  BillCopyIsNotAvailable: t('allocations.skipped_bill_copy_not_available'),
  NoActiveResidents: t('allocations.skipped_no_active_residents'),
  OffCycle: t('allocations.skipped_off_cycle'),
  Other: t('allocations.skipped_other')
});
export const billStatuses = t => ({
  PendingApproval: {
    label: t('allocations.to_approve'),
    variant: 'info'
  },
  PendingCompletion: {
    label: t('allocations.pending_completion'),
    variant: 'warning'
  },
  SubmeterChargesSent: {
    label: t('allocations.sent_out'),
    variant: 'success'
  },
  TableReady: {
    label: t('allocations.table_is_ready'),
    variant: 'success'
  },
  TableReadyStatementSent: {
    label: t('allocations.sent_out'),
    variant: 'successBold'
  },
  TableSkipped: {
    label: t('allocations.skipped'),
    variant: 'critical'
  }
});
export const VACANT_UNIT_OCCUPANTS_COUNT = {
  min: 1,
  max: 10
};
const OCCUPANCY_BASED_ALLOCATION_METHODS = [ALLOCATION_METHOD.ByOccupancy, ALLOCATION_METHOD.By50Occupancy50SquareFootage, ALLOCATION_METHOD.ByNumberOfOccupants];

/** The vacant unit occupant count only changes a bill when the utility splits by occupants. */
export const isOccupancyBasedAllocationMethod = allocationMethod => OCCUPANCY_BASED_ALLOCATION_METHODS.includes(allocationMethod !== null && allocationMethod !== void 0 ? allocationMethod : '');

/**
 * The count a save sends for an opted-in company: the pick on Full usage, otherwise null so the
 * server clears it. Callers for companies that have not opted in send nothing and the server keeps
 * whatever is stored.
 */
export const vacantUnitOccupantsCountToSave = (isEnabled, vacantUnitUsage, count) => isEnabled && vacantUnitUsage === VACANT_UNIT_USAGE.NormalUsage ? count || VACANT_UNIT_OCCUPANTS_COUNT.min : null;

/** " · 2 occupants" after "Full usage" once the count is above the default of one. */
export const vacantUnitOccupantsSummarySuffix = (t, vacantUnitUsage, count) => vacantUnitUsage === VACANT_UNIT_USAGE.NormalUsage && count && count > 1 ? " \xB7 ".concat(t('add_new_property_flow.vacant_unit_occupants_summary', {
  count
})) : '';